// extracted by mini-css-extract-plugin
export default {"inner":"Destinations_inner__tM4tl","head":"Destinations_head__l+Hhp","wrapper":"Destinations_wrapper__Hd+pZ","button":"Destinations_button__ih6av"};